import { useDocumentTitle } from '../app/useDocumentTitle';
import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { useT } from '../i18n/i18n';
import styles from './StatusPage.module.css';

export function NotFoundPage() {
  const t = useT();
  useDocumentTitle(t('notFound.title'));
  return (
    <main className={styles.page}>
      <Link to="/" aria-label="miroom">
        <Logo />
      </Link>
      <div className={styles.art} aria-hidden="true">
        404
      </div>
      <h1 className={styles.title}>{t('notFound.title')}</h1>
      <p className={styles.text}>{t('notFound.text')}</p>
      <Link to="/" className={styles.link}>
        {t('notFound.home')}
      </Link>
    </main>
  );
}
